import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import store from "store";
import theme from "theme/theme";
import { Provider } from "react-redux";
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from "@mui/material/styles";
import { TOContextProvider } from "context/TContext";
import { BrowserRouter as Router } from "react-router-dom";
import { PaymentSystemProvider } from 'context/PaymentSystemContext';

// Optimized providers wrapper
const AppProviders = ({ children }) => (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PaymentSystemProvider>
          <TOContextProvider>
            <Router>
              {children}
            </Router>
          </TOContextProvider>
        </PaymentSystemProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppProviders>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick={true}
      pauseOnHover={true}
      draggable={false}
      pauseOnFocusLoss={false}
      limit={3}
    />
  </AppProviders>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
